import { ReactElement } from "react";
import {
	FormattedText,
	Typography
} from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { setTrackingId } from "client/Misc/utils";
import { prepareHubItemTitle } from "./AnnouncementActivity";
import { getComputedDisplayName } from "client/Features/AddressBook/common";
import { InlineIcon } from "./InlineIcon/InlineIcon";
import { KnowledgeItemCommentMentionNotificationDataViewModel } from "client/Api/Notifications/notifications";

export type KnowledgeItemCommentMentionActivityProps = {
	data: KnowledgeItemCommentMentionNotificationDataViewModel;
};

export const KnowledgeItemCommentMentionActivity = (props: KnowledgeItemCommentMentionActivityProps): ReactElement => {
	const { data } = props;
	const {
		firstname,
		lastname
	} = data;

	const title: string = prepareHubItemTitle(data.title);

	const {
		computedDisplayName
	} = getComputedDisplayName({
		firstName: firstname,
		lastName: lastname
	});

	return (
		<>
			<span {...setTrackingId("title")}>
				<InlineIcon
					icon={{
						kind: "font",
						name: "at",
						color: "primary"
					}}
				/>
				<FormattedText
					text={localize("_UserXMentionedYouInKnowledgeArticleTitleY")}
					thingsToReplace={[
						{
							what: "{{Username}}",
							filler: (
								<span {...setTrackingId("user-name")}>
									{computedDisplayName}
								</span>
							)
						},
						{
							what: "{{Title}}",
							filler: (
								<Typography
									trackingId="knowledge-item-title"
									weight="bold"
								>
									{title}
								</Typography>
							)
						}
					]}
				/>
			</span>
		</>
	);
};

KnowledgeItemCommentMentionActivity.displayName = "KnowledgeItemCommentMentionActivity";
